import { format } from 'date-fns'
import { checkDate } from '../assets/assets_functions'
import { langTabMeteo } from '../assets/langTabMeteo'
import { useLang } from '../utils/hooks'

const TabMeteo = ({ timeDomain, timeZone, lat, lng }) => {
  const { lang } = useLang()
  const choosenLang = lang === 'fr' ? langTabMeteo.fr : langTabMeteo.eng

  const thClass = 'is-size-6 has-text-info-dark'
  const tdClass = 'is-size-6 has-text-info-dark has-text-right'

  const startTime = timeDomain[0]
  const endTime = timeDomain[1]

  const start = checkDate(new Date(startTime))
  const start_str = format(start, 'dd-MM-yyyy HH:mm', {
    timeZone: timeZone,
  })
  const end = checkDate(new Date(endTime))
  const end_str = format(end, 'HH:mm', {
    timeZone: timeZone,
  })

  return (
    <div>
      <table className="table is-fullwidth background-very-light-info">
        <tbody>
          <tr>
            <th className={thClass}>{choosenLang.sessionStart}</th>
            <td className={tdClass}>{start_str}</td>
          </tr>
          <tr>
            <th className={thClass}>{choosenLang.sessionEnd}</th>
            <td className={tdClass}>{end_str}</td>
          </tr>
          <tr>
            <th className={thClass}>{choosenLang.sessionCoord}</th>
            <td className={tdClass}>{'Lat ' + lat + ' Lng ' + lng}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
export default TabMeteo
